import Hdri from './Hdri.vue';

export default Hdri;
